export default {
  init() {
    /* global currentLanguage */
    if (typeof window.CookieConsent !== 'undefined') {
      window.CookieConsent.init({
        // More link URL on bar.
        modalMainTextMoreLink: null,
        // How long to wait until bar comes up.
        barTimeout: 500,
        // Look and feel.
        theme: {
          barColor: '#FFF',
          barTextColor: '#234557',
          barMainButtonColor: '#234557',
          barMainButtonTextColor: '#fff',
          modalMainButtonColor: '#234557',
          modalMainButtonTextColor: '#fff',
        },
        language: {
          current: currentLanguage,
          locale: {
            sv: {
              barMainText:
                'Vi använder cookies och behandlar personuppgifter för att leverera tjänster till dig, vidareutveckla våra tjänster och personalisera innehåll.',
              closeAriaLabel: 'stäng',
              barLinkSetting: 'Cookie-inställningar',
              barBtnAcceptAll: 'Acceptera alla cookies',
              modalMainTitle: 'Cookie-inställningar',
              modalMainText:
                'Cookies är små datastycken som skickas från en webbplats och lagras på användarens dator av användarens webbläsare medan användaren surfar. Din webbläsare lagrar varje meddelande i en liten fil, kallad cookie. När du begär en annan sida från servern skickar din webbläsare tillbaka cookien till servern. Cookies designades för att vara en pålitlig mekanism för webbplatser att komma ihåg information eller att registrera användarens surfaktivitet.',
              modalBtnSave: 'Spara aktuella inställningar',
              modalBtnAcceptAll: 'Acceptera alla cookies och stäng',
              modalAffectedSolutions: 'Påverkade lösningar:',
              learnMore: 'Läs mer',
              on: 'På',
              off: 'Av',
              enabled: 'är aktiverad.',
              disabled: 'är inaktiverad.',
              checked: 'markerad',
              unchecked: 'omarkerad',
            },
            en: {
              barMainText:
                'We use cookies and process personal data to deliver services to you, further develop our services and personalize content.',
              closeAriaLabel: 'close',
              barLinkSetting: 'Cookie settings',
              barBtnAcceptAll: 'Accept all cookies',
              modalMainTitle: 'Cookie settings',
              modalMainText:
                'Cookies are small pieces of data sent from a website and stored on the user\'s computer by the user\'s web browser while the user is browsing. Your browser stores each message in a small file, called a cookie. When you request another page from the server, your browser sends the cookie back to the server. Cookies were designed to be a reliable mechanism for websites to remember information or to record the user\'s browsing activity.',
              modalBtnSave: 'Save current settings',
              modalBtnAcceptAll: 'Accept all cookies and close',
              modalAffectedSolutions: 'Affected solutions:',
              learnMore: 'Learn more',
              on: 'On',
              off: 'Off',
              enabled: 'is enabled.',
              disabled: 'is disabled.',
              checked: 'checked',
              unchecked: 'unchecked',
            },
            da: {
              barMainText:
                'Vi bruger cookies og behandler personoplysninger for at levere tjenester til dig, videreudvikle vores tjenester og personalisere indhold.',
              closeAriaLabel: 'luk',
              barLinkSetting: 'Cookieindstillinger',
              barBtnAcceptAll: 'Accepter alle cookies',
              modalMainTitle: 'Cookieindstillinger',
              modalMainText:
                'Cookies er små datastykker, der sendes fra en hjemmeside og gemmes på brugerens computer af brugerens webbrowser, mens brugeren browser. Din browser gemmer hver besked i en lille fil, kaldet en cookie. Når du anmoder om en anden side fra serveren, sender din browser cookien tilbage til serveren. Cookies blev designet til at være en pålidelig mekanisme for hjemmesider til at huske information eller registrere brugerens browseraktivitet.',
              modalBtnSave: 'Gem nuværende indstillinger',
              modalBtnAcceptAll: 'Accepter alle cookies og luk',
              modalAffectedSolutions: 'Berørte løsninger:',
              learnMore: 'Lær mere',
              on: 'Tændt',
              off: 'Slukket',
              enabled: 'er aktiveret.',
              disabled: 'er deaktiveret.',
              checked: 'afkrydset',
              unchecked: 'ikke afkrydset',
            },
            lt: {
              barMainText:
                'Mes naudojame slapukus ir apdorojame asmeninius duomenis, kad galėtume jums teikti paslaugas, toliau tobulinti mūsų paslaugas ir pritaikyti turinį.',
              closeAriaLabel: 'uždaryti',
              barLinkSetting: 'Slapukų nustatymai',
              barBtnAcceptAll: 'Priimti visus slapukus',
              modalMainTitle: 'Slapukų nustatymai',
              modalMainText:
                'Slapukai yra mažos duomenų dalys, siunčiamos iš svetainės ir saugomos naudotojo kompiuteryje naudotojo interneto naršyklės, kai naudotojas naršo. Kiekvieną pranešimą jūsų naršyklė saugo mažame faile, vadinamame slapuku. Kai iš serverio prašote kitos puslapio, jūsų naršyklė vėl siunčia slapuką į serverį. Slapukai buvo suprojektuoti būti patikima svetainių mechanizmas, kad galėtų prisiminti informaciją arba užfiksuoti vartotojo naršymo veiklą.',
              modalBtnSave: 'Išsaugoti dabartines nustatymus',
              modalBtnAcceptAll: 'Priimti visus slapukus ir uždaryti',
              modalAffectedSolutions: 'Paveiktos sprendimai:',
              learnMore: 'Sužinokite daugiau',
              on: 'Įjungti',
              off: 'Išjungti',
              enabled: 'įjungtas.',
              disabled: 'išjungtas.',
              checked: 'pažymėtas',
              unchecked: 'nepažymėtas',
            },
            fi: {
              barMainText:
                'Käytämme evästeitä ja käsittelemme henkilötietoja tarjotaksemme palveluja sinulle, kehittääksemme palvelujamme edelleen ja personoidaksemme sisältöä.',
              closeAriaLabel: 'sulje',
              barLinkSetting: 'Evästeasetukset',
              barBtnAcceptAll: 'Hyväksy kaikki evästeet',
              modalMainTitle: 'Evästeasetukset',
              modalMainText:
                'Evästeet ovat pieniä tietopaketteja, jotka lähetetään verkkosivustolta ja tallennetaan käyttäjän tietokoneeseen käyttäjän selaimen toimesta, kun käyttäjä selailee. Selain tallentaa jokaisen viestin pienessä tiedostossa, jota kutsutaan evästeeksi. Kun pyydät toista sivua palvelimelta, selain lähettää evästeen takaisin palvelimelle. Evästeet on suunniteltu olemaan luotettava mekanismi verkkosivustoille muistaa tietoja tai tallentaa käyttäjän selaustoimintaa.',
              modalBtnSave: 'Tallenna nykyiset asetukset',
              modalBtnAcceptAll: 'Hyväksy kaikki evästeet ja sulje',
              modalAffectedSolutions: 'Vaikuttavat ratkaisut:',
              learnMore: 'Lue lisää',
              on: 'Päällä',
              off: 'Pois päältä',
              enabled: 'on käytössä.',
              disabled: 'ei ole käytössä.',
              checked: 'valittu',
              unchecked: 'valitsematon',
            },
            no: {
              barMainText:
                'Vi bruker informasjonskapsler og behandler personopplysninger for å levere tjenester til deg, videreutvikle våre tjenester og tilpasse innhold.',
              closeAriaLabel: 'lukk',
              barLinkSetting: 'Informasjonskapselinnstillinger',
              barBtnAcceptAll: 'Godta alle informasjonskapsler',
              modalMainTitle: 'Informasjonskapselinnstillinger',
              modalMainText:
                'Informasjonskapsler er små datastykker som sendes fra et nettsted og lagres på brukerens datamaskin av brukerens nettleser mens brukeren surfer. Nettleseren lagrer hver melding i en liten fil kalt en informasjonskapsel. Når du ber om en annen side fra serveren, sender nettleseren informasjonskapselen tilbake til serveren. Informasjonskapsler ble designet for å være en pålitelig mekanisme for nettsteder å huske informasjon eller registrere brukerens nettleseraktivitet.',
              modalBtnSave: 'Lagre gjeldende innstillinger',
              modalBtnAcceptAll: 'Godta alle informasjonskapsler og lukk',
              modalAffectedSolutions: 'Berørte løsninger:',
              learnMore: 'Lær mer',
              on: 'På',
              off: 'Av',
              enabled: 'er aktivert.',
              disabled: 'er deaktivert.',
              checked: 'avmerket',
              unchecked: 'ikke avmerket',
            },
            pt: {
              barMainText:
                'Utilizamos cookies e processamos dados pessoais para fornecer serviços a você, desenvolver ainda mais nossos serviços e personalizar conteúdo.',
              closeAriaLabel: 'fechar',
              barLinkSetting: 'Configurações de cookies',
              barBtnAcceptAll: 'Aceitar todos os cookies',
              modalMainTitle: 'Configurações de cookies',
              modalMainText:
                'Os cookies são pequenos pedaços de dados enviados de um site e armazenados no computador do usuário pelo navegador do usuário enquanto o usuário navega. Seu navegador armazena cada mensagem em um pequeno arquivo, chamado cookie. Quando você solicita outra página do servidor, seu navegador envia o cookie de volta para o servidor. Os cookies foram projetados para serem um mecanismo confiável para sites lembrarem informações ou registrarem a atividade de navegação do usuário.',
              modalBtnSave: 'Salvar configurações atuais',
              modalBtnAcceptAll: 'Aceitar todos os cookies e fechar',
              modalAffectedSolutions: 'Soluções afetadas:',
              learnMore: 'Saiba mais',
              on: 'Ligado',
              off: 'Desligado',
              enabled: 'está ativado.',
              disabled: 'está desativado.',
              checked: 'selecionado',
              unchecked: 'não selecionado',
            },
          },
        },
        // List all the categories you want to display.
        categories: {
          necessary: {
            needed: true,
            // The cookies in this category will be let trough.
            // This probably should be false if category not necessary.
            wanted: true,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'Nödvändiga',
                  description:
                    'Nödvändiga cookies hjälper dig att göra en hemsida användbar, genom att aktivera grundläggande funktioner såsom sidnavigering åtkomst till säkra områden på hemsidan. Hemsidan kan inte fungera optimalt utan dessa cookies.',
                },
                en: {
                  name: 'Necessary',
                  description:
                    'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
                },
                lt: {
                  name: 'Būtini',
                  description:
                    'Būtini slapukai padeda padaryti svetainę naudojamą, įgalinant pagrindines funkcijas, tokių kaip puslapio naršymas ir prieiga prie svetainės saugomų sričių. Svetainė negali tinkamai veikti be šių slapukų.',
                },
                da: {
                  name: 'Nødvendige',
                  description:
                    'Nødvendige cookies hjælper med at gøre en hjemmeside brugbar ved at aktivere grundlæggende funktioner som side-navigation og adgang til sikre områder af hjemmesiden. Hjemmesiden kan ikke fungere korrekt uden disse cookies.',
                },
                fi: {
                  name: 'Välttämättömät',
                  description:
                    'Välttämättömät evästeet auttavat tekemään verkkosivustosta käyttökelpoisen sallimalla perustoimintoja kuten sivunavigoinnin ja pääsyn verkkosivuston turvallisiin alueisiin. Verkkosivusto ei voi toimia asianmukaisesti ilman näitä evästeitä.',
                },
                no: {
                  name: 'Nødvendige',
                  description:
                    'Nødvendige informasjonskapsler hjelper med å gjøre en nettside brukbar ved å aktivere grunnleggende funksjoner som side-navigasjon og tilgang til sikre områder av nettsiden. Nettsiden kan ikke fungere skikkelig uten disse informasjonskapslene.',
                },
                pt: {
                  name: 'Necessários',
                  description:
                    'Os cookies necessários ajudam a tornar um site utilizável, permitindo funções básicas como navegação de página e acesso a áreas seguras do site. O site não pode funcionar corretamente sem esses cookies.',
                },
              },
            },
          },
          statistic: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'Statistiska',
                  description:
                    'Statistiska cookies hjälper hemsidans ägare att förstå hur besökare interagerar med hemsidan, genom att samla in och rapportera uppgifter.',
                },
                en: {
                  name: 'Statistical cookies',
                  description:
                    'Statistical cookies help website owners understand how visitors interact with the website by collecting and reporting information.',
                },
                lt: {
                  name: 'Statistiniai slapukai',
                  description:
                    'Statistiniai slapukai padeda svetainės savininkams suprasti, kaip lankytojai sąveikauja su svetaine, renkant ir pranešant informaciją.',
                },
                da: {
                  name: 'Statistiske cookies',
                  description:
                    'Statistiske cookies hjælper hjemmesideejere med at forstå, hvordan besøgende interagerer med hjemmesiden ved at indsamle og rapportere information.',
                },
                fi: {
                  name: 'Tilastolliset evästeet',
                  description:
                    'Tilastolliset evästeet auttavat verkkosivuston omistajia ymmärtämään, miten kävijät vuorovaikuttavat verkkosivuston kanssa keräämällä ja raportoimalla tietoja.',
                },
                no: {
                  name: 'Statistiske informasjonskapsler',
                  description:
                    'Statistiske informasjonskapsler hjelper nettsideeiere med å forstå hvordan besøkende samhandler med nettsiden ved å samle inn og rapportere informasjon.',
                },
                pt: {
                  name: 'Cookies estatísticos',
                  description:
                    'Os cookies estatísticos ajudam os proprietários de sites a entender como os visitantes interagem com o site, coletando e relatando informações.',
                },
              },
            },
          },
          marketing: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'Marknadsföring',
                  description:
                    'Marketingcookies används för att spåra besökare gränsöverskridande på hemsidor. Avsikten är att visa annonser som är relevanta och engagerande för den enskilda användaren och därmed vara mer värdefulla för utgivare och tredjepartsannonsörer.',
                },
                en: {
                  name: 'Marketing',
                  description:
                    'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third-party advertisers.',
                },
                lt: {
                  name: 'Rinkodaros slapukai',
                  description:
                    'Rinkodaros slapukai naudojami stebėti lankytojus tarp svetainių. Tikslas yra rodyti skelbimus, kurie yra relevantiški ir įtraukiantys individualiam vartotojui ir taip pat vertingesni leidėjams ir trečiųjų šalių reklamuotojams.',
                },
                da: {
                  name: 'Markedsføringscookies',
                  description:
                    'Markedsføringscookies bruges til at spore besøgende på tværs af websteder. Hensigten er at vise annoncer, der er relevante og engagerende for den enkelte bruger og dermed mere værdifulde for udgivere og tredjeparts annoncører.',
                },
                fi: {
                  name: 'Markkinointievästeet',
                  description:
                    'Markkinointievästeitä käytetään seuraamaan kävijöitä eri verkkosivustoilla. Tarkoituksena on näyttää mainoksia, jotka ovat relevanteja ja kiinnostavia yksittäiselle käyttäjälle ja siten arvokkaampia julkaisijoille ja kolmannen osapuolen mainostajille.',
                },
                no: {
                  name: 'Markedsføringsinformasjonskapsler',
                  description:
                    'Markedsføringsinformasjonskapsler brukes til å spore besøkende på tvers av nettsteder. Hensikten er å vise annonser som er relevante og engasjerende for den enkelte bruker, og dermed mer verdifulle for utgivere og tredjeparts annonsører.',
                },
                pt: {
                  name: 'Marketing',
                  description:
                    'Cookies de marketing são usados para rastrear visitantes entre sites. A intenção é exibir anúncios relevantes e envolventes para o usuário individual e, portanto, mais valiosos para editores e anunciantes de terceiros.',
                },
              },
            },
          },
        },
        // List actual services here.
        services: {
          // Unique name.
          analytics: {
            // Existing category Unique name.
            // This example shows how to block Google Analytics.
            category: 'statistic',
            // Type of blocking to apply here.
            // This depends on the type of script we are trying to block.
            // Can be: dynamic-script, script-tag, wrapped, localcookie.
            type: 'dynamic-script',
            // Only needed if 'type: dynamic-script'.
            // The filter will look for this keyword in inserted scipt tags
            //  and block if match found.
            search: 'analytics',
            // List of known cookie names or regular expressions matching
            //  cookie names placed by this service.
            // These will be removed from current domain and .domain.
            cookies: [
              {
                // Known cookie name.
                name: '_gid',
                // Expected cookie domain.
                domain: `.${window.location.hostname}`,
              },
              {
                // Regex matching cookie name.
                name: /^_ga/,
                domain: `.${window.location.hostname}`,
              },
            ],
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'Google Analytics',
                },
                en: {
                  name: 'Google Analytics',
                },
                lt: {
                  name: 'Google Analytics',
                },
                da: {
                  name: 'Google Analytics',
                },
                fi: {
                  name: 'Google Analytics',
                },
                no: {
                  name: 'Google Analytics',
                },
                pt: {
                  name: 'Google Analytics',
                },
              },
            },
          },
          hotjar_script_tag: {
            category: 'statistic',
            type: 'script-tag',
            search: 'hotjar',
            cookies: [
              {
                name: /^_hj/,
                domain: `.${window.location.hostname}`,
              },
            ],
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'Google Tag Manager',
                },
                en: {
                  name: 'Google Tag Manager',
                },
                de: {
                  name: 'Google Tag Manager',
                },
              },
            },
          },
          facebook_script_tag: {
            category: 'statistic',
            type: 'script-tag',
            search: 'facebook',
            cookies: [
              {
                // Regex matching cookie name.
                name: /^_fb/,
                domain: `.${window.location.hostname}`,
              },
            ],
            language: {
              locale: {
                sv: {
                  name: 'Facebook Meta Pixel',
                },
                en: {
                  name: 'Facebook Meta Pixel',
                },
                lt: {
                  name: 'Facebook Meta Pixel',
                },
                da: {
                  name: 'Facebook Meta Pixel',
                },
                fi: {
                  name: 'Facebook Meta Pixel',
                },
                no: {
                  name: 'Facebook Meta Pixel',
                },
                pt: {
                  name: 'Facebook Meta Pixel',
                },
              },
            },
          },
          linkedIn_script_tag: {
            category: 'marketing',
            type: 'script-tag',
            search: 'licdn',
            cookies: [
              {
                // Regex matching cookie name.
                name: /^.li_/,
                domain: '.linkedin.com',
              },
            ],
            language: {
              locale: {
                sv: {
                  name: 'LinkedIn',
                },
                en: {
                  name: 'LinkedIn',
                },
                lt: {
                  name: 'LinkedIn',
                },
                da: {
                  name: 'LinkedIn',
                },
                fi: {
                  name: 'LinkedIn',
                },
                no: {
                  name: 'LinkedIn',
                },
                pt: {
                  name: 'LinkedIn',
                },
              },
            },
          },
          inZynk_script_tag: {
            category: 'marketing',
            type: 'script-tag',
            search: 'inzynk',
            cookies: [
              {
                name: 'iztid',
                domain: `${window.location.hostname}`,
              },
              {
                name: 'iztid',
                domain: '.inzynk.io',
              },
              {
                name: 'izcid',
                domain: `${window.location.hostname}`,
              },
            ],
            language: {
              current: currentLanguage,
              locale: {
                sv: {
                  name: 'inZynk',
                },
                en: {
                  name: 'inZynk',
                },
                de: {
                  name: 'inZynk',
                },
              },
            },
          },
          
        },
        consentModeControls: {
          ad_storage: 'marketing',
          ad_user_data: 'marketing',
          ad_personalization: 'marketing',
          analytics_storage: 'statistic',
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cookies.js